// extracted by css-extract-rspack-plugin
export default {"paginationList":"_6ff3c95b","w48px":"_eb998626","w48Px":"_eb998626"};